export class DeviceId {
    public static UNKOWN: number = 0;
    public static DESKTOP: number = 1;
    public static IPAD: number = 2;
    public static IPOD: number = 3;
    public static IPHONE: number = 4;
    public static ANDROID_PHONE: number = 5;
    public static ANDROID_TABLET: number = 7;
    public static AMAZON_DEVICE: number = 9;
}
